import React, { useState, useMemo, useEffect } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { Modal, Box, Button, Stack, Snackbar, Alert, IconButton, Typography } from '@mui/material';
import { Select, MenuItem } from '@mui/material';
import * as XLSX from 'xlsx';
import GeneratedObject from './../../components/GeneratedObject'
import EditIcon from '@mui/icons-material/Edit';

const InventoryBrowser = () => {
  const [tableData, setTableData] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [labwareBlueprints, setLabwareBlueprints] = useState([]);
  const [responseData, setResponseData] = useState(null);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [storageList, setStorageList] = useState([]);
  const [selectedStorage, setSelectedStorage] = useState('');
  const [openEditModal, setOpenEditModal] = useState(false);
  const [inputId, setInputId] = useState('');
  // Define columns for the MaterialReactTable with edit button action
  const columns = useMemo(() => [
    { accessorKey: 'Storage', header: 'Storage', enableEditing: true, size: 100 },
    { accessorKey: 'ID', header: 'ID', enableEditing: true, size: 100 },
    { accessorKey: 'Label', header: 'Label', enableEditing: true, size: 100 },
    { accessorKey: 'Description', header: 'Description', enableEditing: true, size: 100 },
    { accessorKey: 'Volume', header: 'Volume', enableEditing: true, size: 100 },
    { accessorKey: 'MolarConcentration', header: 'Molar Concentration', enableEditing: true, size: 100 },
    { accessorKey: 'MassConcentration', header: 'Mass Concentration', enableEditing: true, size: 100 },
    { accessorKey: 'Mass', header: 'Mass', enableEditing: true, size: 100 },
    {
      accessorKey: 'Edit',
      header: 'Edit',
      Cell: ({ row }) => (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <IconButton
            onClick={() => handleEditClick(row.original)}//on edit click open my customized form that contains the portal and the storage list drop down menu
            style={{ padding: '2px', color: '#2196F3', fontSize: '0.75rem' }}
            aria-label="Edit"
          >
            <EditIcon fontSize="small" />
          </IconButton>
          <span style={{ fontSize: '0.75rem', marginTop: '4px' }}>Edit</span>
        </div>
      ),
    }
    ,
  ], []);
  const handleEditClick = async (rowData) => { //opens the edit form and requests for storage list for the drop down menu
    await fetchStorageOptions();//request the storage list for the drop down menu for the edit form
    setOpenEditModal(true);  // Open the edit modal 
    setInputId(rowData.ID); // Set the inputId state from the id of the edited row
  };

  const handleExport = () => {
    const ws = XLSX.utils.json_to_sheet(tableData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'data.xlsx');
  };
  const handleImport = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: null });

      const modifiedData = jsonData.map((row) => {
        const modifiedRow = { ...row };
        for (const key in modifiedRow) {
          if (modifiedRow[key] === null || modifiedRow[key] === '') {
            modifiedRow[key] = '#';
          }
        }
        return modifiedRow;
      });

      setTableData(modifiedData);
    };

    reader.readAsArrayBuffer(file);
  };
  const handleAddRow = async () => { //list Labware Blueprints in a modal form 
    const url = process.env.REACT_APP_ELN_SERVER_URL;
    const requestData = {
      "username": "gerard",
      "func": "listLabwareBlueprints",
      "params": {}
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("add row", data)
      setLabwareBlueprints(data.result || []);//set the data to be displayed in the table
      setOpenModal(true); // Open the modal after fetching
      setSnackbarMessage('Labware blueprints fetched successfully!');// message on the bottom left
      setOpenSnackbar(true);
    } catch (error) {
      console.error('Error fetching data from server:', error);
      setSnackbarMessage('Failed to fetch data from server.');// message on the bottom left
      setOpenSnackbar(true);
    }
  };
  const handleCloseModal = () => {
    setOpenModal(false);//close the open modal or popup form on cancel click
  };
  const handleButtonClick = async (id) => {//when clicking on an option from the list Labware Blueprints ,request to createLabwareFromBlueprint and open the form to fill it
    const url = process.env.REACT_APP_ELN_SERVER_URL;
    const requestDataBlueprint = {
      "username": "gerard",
      "func": "createLabwareFromBlueprint",
      "params": { "id": id }
    };
    // Fetch the blueprint response
    try {
      const responseBlueprint = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestDataBlueprint),
      });

      if (!responseBlueprint.ok) {
        throw new Error(`HTTP error! Status: ${responseBlueprint.status}`);
      }

      const dataBlueprint = await responseBlueprint.json();//the newly created object 
      setResponseData(dataBlueprint.result); // Store the response data of the newly created object
      setShowResponseModal(true); // Open the newly created object modal/form
      await fetchStorageOptions(); // list Storage For User when opening the modal

    } catch (error) {
      console.error('Error fetching data from server:', error);
      setSnackbarMessage('Failed to fetch data from server.');
      setOpenSnackbar(true);
    }

    handleCloseModal(); // Close the modal/form
  };

  // Fetch storage options function
  const fetchStorageOptions = async () => { // request the list of Storage For User when opening the modal
    const url = process.env.REACT_APP_ELN_SERVER_URL;
    const requestDataStorage = {
      "username": "gerard",
      "func": "listStorageForUser",
      "params": {}
    };

    try {
      const responseStorage = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestDataStorage),
      });

      if (!responseStorage.ok) {
        throw new Error(`HTTP error! Status: ${responseStorage.status}`);
      }

      const dataStorage = await responseStorage.json();

      // Set the storage list using the correct field names
      setStorageList(dataStorage.result.map(storage => ({
        id: storage._id,  // Store the _id as the id
        name: storage.Name // Use Name as the display name
      })));//set the list in the storage list 

    } catch (error) {
      console.error('Error fetching storage data:', error);
      setSnackbarMessage('Failed to fetch storage data.');
      setOpenSnackbar(true);
    }
  };

  const handleCancelResponse = async () => {
    setShowResponseModal(false);//close modal/form
    setOpenEditModal(false);//close modal/form
    await handleSendToServer(); //get all data (like refresh here afer update)
  };
  const handleSendToServer = async () => { //reuqest list of Labware For User that will be displayed in the table
    const url = process.env.REACT_APP_ELN_SERVER_URL;
    const requestData = {
      "username": "gerard",
      "func": "listLabwareForUser",
      "params": {}
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      // Assuming `data.result` is the array, map the fields and handle missing values
      const formattedData = (data.result || []).map(item => ({
        Storage: item._eln_storage_obj_name || '#', // Use _id as storage identifier, or show # if no storage or null
        ID: item._id || '#', // Use _id as storage identifier, or show # if no storage or null
        Label: item.Label || '#', // Fall back to # if missing
        Description: item.Description || '#', // Optional description
        Volume: item.Content?.Volume || '#', // Nested field
        MolarConcentration: item.Content?.["Molar Conc."] || '#', // Handle nested with key containing spaces
        MassConcentration: item.Content?.["Mass Conc."] || '#', // Handle nested field
        Mass: item.Content?.Mass || '#', // Nested field
      }));
      // Update the state with the formatted data for the table
      setTableData(formattedData);//list of Labware For User 
      // show success message
      setSnackbarMessage('Data fetched and table updated successfully.');
      setOpenSnackbar(true);

    } catch (error) {
      console.error('Error fetching data from server:', error);
      setSnackbarMessage('Failed to fetch data from server.');
      setOpenSnackbar(true);
    }
  };
  useEffect(() => {
    handleSendToServer();
  }, []);
  const handleDeleteResponse = async (LabwareID) => { // request for deleting the newly created object
    const url = process.env.REACT_APP_ELN_SERVER_URL;
    const requestData = {
      "username": "gerard",
      "func": "deleteLabware",
      "params": {
        "id": LabwareID
      }
    };
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Delete", data)
      // Optionally show success message
      setSnackbarMessage('Data deleted successfully.');
      setOpenSnackbar(true);

    } catch (error) {
      console.error('Error deleting data from server:', error);
      setSnackbarMessage('Failed to delete data from server.');
      setOpenSnackbar(true);
    }
  };
  const handleUpdateLabwareStorage = async (newStorageId, storageName) => { //update storage when choosing from drop down menu in the newly created object modal/form
    const url = process.env.REACT_APP_ELN_SERVER_URL;
    const requestData = {
      "username": "gerard",
      "func": "updateLabwareStorage",
      "params": {
        "id": responseData._id,
        "storage_id": newStorageId,
      }
    };
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Update the table data with the new storage name
      setTableData(prevData =>
        prevData.map(item =>
          item.ID === responseData._id // Match the ID of the item
            ? { ...item, Storage: storageName } // Update the Storage field
            : item
        )
      );

      setSnackbarMessage('Labware storage updated successfully!');
      setOpenSnackbar(true);

    } catch (error) {
      console.error('Error updating labware storage:', error);
      setSnackbarMessage('Failed to update labware storage.');
      setOpenSnackbar(true);
    }
  };
  const handleUpdateLabwareStorageForEdit = async (newStorageId, storageName, editID) => { //same func but when editing i don't have the response id,i took the id from the edited row
    const url = process.env.REACT_APP_ELN_SERVER_URL;
    const requestData = {
      "username": "gerard",
      "func": "updateLabwareStorage",
      "params": {
        "id": editID, // Ensure this ID is correct
        "storage_id": newStorageId, // Ensure this is the correct field
      }
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Update the table data with the new storage name
      setTableData(prevData =>
        prevData.map(item =>
          item.ID === editID // Match the ID of the item
            ? { ...item, Storage: storageName } // Update the Storage field
            : item
        )
      );

      setSnackbarMessage('Labware storage updated successfully!');
      setOpenSnackbar(true);

    } catch (error) {
      console.error('Error updating labware storage:', error);
      setSnackbarMessage('Failed to update labware storage.');
      setOpenSnackbar(true);
    }
  };

  return (
    <Box sx={{ padding: 3, backgroundColor: '#f4f6f8', borderRadius: '8px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
      {/* Heading */}
      <Typography variant="h4" component="h1" sx={{ marginBottom: 2, fontWeight: 'bold', textAlign: 'left' }}>
        Labware Central
      </Typography>

      {/* Button Stack */}
      <Stack direction="row" spacing={2} mb={3} justifyContent="left">
        <Button variant="contained" component="label" color="primary" sx={{ padding: '8px 16px', fontWeight: 'bold' }}>
          Import
          <input type="file" hidden onChange={handleImport} />
        </Button>
        <Button variant="contained" color="secondary" onClick={handleExport} sx={{ padding: '8px 16px', fontWeight: 'bold' }}>
          Export
        </Button>
        <Button variant="contained" color="info" onClick={handleAddRow} sx={{ padding: '8px 16px', fontWeight: 'bold' }}>
          Add Row
        </Button>
      </Stack>

      {/* Material Table */}
      <MaterialReactTable
        columns={columns}
        data={tableData}
        muiTableContainerProps={{
          sx: {
            maxHeight: '500px',
            overflowY: 'auto',
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
          },
        }}
        muiTableHeadCellProps={{
          sx: {
            fontWeight: 'bold',
            fontSize: '14px',
            backgroundColor: '#e0e0e0',
            textAlign: 'center',
          },
        }}
        muiTableBodyCellProps={{
          sx: {
            fontSize: '13px',
            padding: '8px',
            textAlign: 'center',
          },
        }}
      />

      {/* Labware Blueprints Modal */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          maxHeight: '80vh',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          overflowY: 'auto',
        }}>
          <Typography variant="h5" component="h2" gutterBottom>
            Select Labware Blueprint
          </Typography>
          {labwareBlueprints.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              No labware blueprints available.
            </Typography>
          ) : (
            labwareBlueprints.map(labware => (
              <Button
                key={labware.id}
                variant="contained"
                onClick={() => handleButtonClick(labware.id)}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                  mb: 2,
                  padding: '10px',
                  fontWeight: 'bold',
                  bgcolor: 'primary.main',
                  color: 'white',
                  '&:hover': {
                    bgcolor: 'primary.dark',
                  },
                }}
              >
                {labware.name}
              </Button>
            ))
          )}
        </Box>
      </Modal>

      {/* Newly Created Object Modal/Form */}
      <Modal open={showResponseModal} onClose={handleCancelResponse}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 1000,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          overflow: 'auto',
          maxHeight: '80vh',
        }}>
          <Typography variant="h6" gutterBottom>
            Labware Created
          </Typography>
          {responseData ? (
            <GeneratedObject
              inputId={responseData._id}
              onError={(data) => {
                console.log(data);
              }}
              onSave={(data) => {
                console.log(data);
              }}
            />
          ) : (
            <Typography variant="body2" color="text.secondary">
              No response data available.
            </Typography>
          )}
          {/* Dropdown for selecting storage */}
          <Typography variant="body2" sx={{ mt: 2 }}>
            Select Storage:
          </Typography>
          <Select
            value={selectedStorage}
            onChange={async (e) => {
              const newStorageId = e.target.value;
              const selectedStorageItem = storageList.find(storage => storage.id === newStorageId);

              if (selectedStorageItem) {
                setSelectedStorage(newStorageId);
                await handleUpdateLabwareStorage(newStorageId, selectedStorageItem.name);
              }
            }}
            fullWidth
          >
            {storageList.map((storage) => (
              <MenuItem key={storage.id} value={storage.id}>
                {storage.name}
              </MenuItem>
            ))}
          </Select>
          <Stack direction="row" spacing={2} mt={2}>
            <Button variant="outlined" color="error" onClick={() => handleDeleteResponse(responseData._id)}>
              Delete
            </Button>
            <Button variant="outlined" color="error" onClick={handleCancelResponse}>
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>

      {/* Edit Modal */}
      <Modal open={openEditModal} onClose={() => setOpenEditModal(false)}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 1000,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          overflow: 'auto',
          maxHeight: '80vh',
        }}>
          <Typography variant="h6" gutterBottom>
            Edit
          </Typography>
          <GeneratedObject
            inputId={String(inputId)}
            onError={(data) => {
              console.log(data);
            }}
            onSave={(data) => {
              console.log(data);
            }}
          />
          {/* Dropdown for selecting storage */}
          <Typography variant="body2" sx={{ mt: 2 }}>
            Select Storage:
          </Typography>
          <Select
            value={selectedStorage}
            onChange={async (e) => {
              const newStorageId = e.target.value;
              const selectedStorageItem = storageList.find(storage => storage.id === newStorageId);

              if (selectedStorageItem) {
                setSelectedStorage(newStorageId);
                await handleUpdateLabwareStorageForEdit(newStorageId, selectedStorageItem.name, inputId);
              }
            }}
            fullWidth
          >
            {storageList.map((storage) => (
              <MenuItem key={storage.id} value={storage.id}>
                {storage.name}
              </MenuItem>
            ))}
          </Select>
          <Stack direction="row" spacing={2} mt={2}>
            <Button variant="outlined" color="error" onClick={handleCancelResponse}>
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>

      {/* Snackbar Message */}
      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={() => setOpenSnackbar(false)}>
        <Alert onClose={() => setOpenSnackbar(false)} severity="info" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );

};

export { InventoryBrowser };
